import { render, staticRenderFns } from "./basicinfo.vue?vue&type=template&id=06e25777&scoped=true"
import script from "./basicinfo.vue?vue&type=script&lang=js"
export * from "./basicinfo.vue?vue&type=script&lang=js"
import style0 from "./basicinfo.vue?vue&type=style&index=0&id=06e25777&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e25777",
  null
  
)

export default component.exports